import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import { Modal, FileInput } from 'components';
import { fetchListOfImageGallery } from 'store/actions/catalogs';
import { hideLoader, showLoader } from 'store/actions/commons';
import { updateGiftTable } from 'store/actions/giftTable';
import { fileToBase64 } from 'services/commons/files';
import uploadIcon from 'assets/img/upload-icon.svg';
import { tablePhotoFormatter } from './formatters';
import styles from './styles.module.scss';
import iconos from 'assets/img/iconos.png';

export default function UploadImageModal({
  dispatch,
  show,
  onClose,
  listOfImageGallery = [],
  setFieldValue,
  values,
  loader = true,
  tableInfo = {}
}) {
  const { selectedImage = {} } = values;
  const handleChange = async (file) => {
    try {
      dispatch(showLoader());

      const imageBase64 = await fileToBase64(file);

      setFieldValue('selectedImage', { image: imageBase64 });
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleSelectImage = ({ image, id }) => {
    setFieldValue('selectedImage', { image, id });
  };

  const handleSubmit = async () => {
    try {
      dispatch(showLoader());

      const imageToUpload = selectedImage.image;

      const hasUrlImage = imageToUpload.includes('.com/');

      const newSelectedImage = {
        title: 'Imagen cargada por el usuario'
      };
      if (hasUrlImage) {
        newSelectedImage.id = selectedImage.id;
      }
      if (imageToUpload && imageToUpload?.includes('base64')) {
        newSelectedImage.image = imageToUpload;
      }

      const payload = tablePhotoFormatter(newSelectedImage);

      setFieldValue('selectedImage', newSelectedImage);

      // this is responsible of hide the loader
      dispatch(
        updateGiftTable({
          ...payload,
          withLoader: true,
          onError: () => dispatch(hideLoader())
        })
      );

      onClose();
    } catch (error) {
      dispatch(hideLoader());
      console.error(error);
    }
  };

  useEffect(() => {
    if (tableInfo) {
      dispatch(fetchListOfImageGallery(loader, tableInfo.type?.id));
    }
  }, [tableInfo]);

  {/*return (
      <Modal
          title=""
          titleHeader="Subir mi foto"
          show={show}
          onClose={onClose}
          className={styles.uploadImageModal}
          onSubmit={handleSubmit}
          actionLabel="Subir foto"
          variant="completed"
          variantOnlyInMobile
          size="lg"
          centered
      >
        <div className={styles.gallery}>
          {selectedImage.image && (
              <Row className="my-2">
                <Col xs={12} md={6}>
                  <div className={styles.imageActive}>
                    <img src={selectedImage.image} alt="Imagen seleccionada" className="img-fluid" />
                  </div>
                </Col>
              </Row>
          )}
        </div>
        <Row className="pb-2 pt-4">
          <Col xs={12}>
            <h4 className="text-center"><b>Carga tu foto desde cualquier lugar</b></h4>
          </Col>
        </Row>
        <Row className="pb-2 pt-4">
          <Col xs={12}>
            <p className="text-center">Imágenes jpg ó png de hasta 10 MB de tamaño.</p>
          </Col>
        </Row>
        <Row className="pb-2 pt-4">
          <Col xs={12} md={6}>
            <FileInput
                groupClassName="m-0 p-0"
                name="tableImage"
                onChange={handleChange}
            >
              {(fileProps) => (
                  <div className={`${styles.uploadPhoto} px-3`}>
                    <Button {...fileProps} variant="secondary">
                      <img src={uploadIcon} alt="Buscar foto" className="mr-2" />
                      Subir archivo
                    </Button>
                  </div>
              )}
            </FileInput>
          </Col>
          <Col xs={12} md={6} className="d-flex align-items-center">
            <div className="ml-md-4">o subir de</div>
          </Col>
        </Row>
      </Modal>
  );*/}

  return (
      <Modal
          size="lg"
          title=""
          titleHeader="Subir mi foto"
          titleHeaderClassName="col-md-6 offset-md-3"
          show={show}
          onClose={onClose}
          className={styles.uploadImageModal}
          onSubmit={handleSubmit}
          actionLabel="Subir foto"
          variant="completed"
          variantOnlyInMobile
          showCancel = {false}
          withHeader = {true}
      >
        <Row className="pb-4">
          <Col xs={12} className="text-center">
            <h4><b>Carga tu foto desde cualquier lugar</b></h4>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs={12} className="text-center">
            <p>Imágenes jpg o png de hasta 10 MB de tamaño.</p>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col xs={12}  className="d-flex justify-content-center align-items-center">
            <FileInput
                groupClassName="m-0 p-0"
                name="tableImage"
                onChange={handleChange}
            >
              {(fileProps) => (
                  <Button {...fileProps} variant="primary" block>
                    <i className="fa fa-upload" /> Subir archivo
                  </Button>
              )}
            </FileInput>
          </Col>
          {/*<Col xs={12} md={6} className="d-flex justify-content-center align-items-center">
            <Col xs={12} md={4} className="d-flex justify-content-center align-items-center"><p>o subir de</p></Col>
            <Col xs={12} md={6} className="d-flex justify-content-center align-items-center">
              <div className={styles.iconoscontainer}>
                <img src={iconos} alt="" />
              </div>
            </Col>
          </Col>*/}
        </Row>
        <Row className="mt-4">
          {selectedImage.image && (
              <Col xs={12} className="text-center">
                <div className={styles.imageActive}>
                  <img src={selectedImage.image} alt="Imagen seleccionada" className="img-fluid" />
                </div>
              </Col>
          )}
        </Row>
      </Modal>
  );
}

UploadImageModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  listOfImageGallery: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      image: PropTypes.string
    })
  ),
  setFieldValue: PropTypes.func.isRequired,
  tableInfo: PropTypes.shape({
    type: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  })
};
